import { http } from '../../../api'

const auth = {
  namespaced: true,
  state: {
    user: {},
    isAuthenticated: false,
    token: null
  },
  actions: {
    sendEmail: ({ commit }, params) => {
      return http.post('/password/email/', params).then(res => {
        return res.data
      })
    },
    checkCode: ({ commit }, params) => {
      return http.post('/password/code/check/', params).then(res => {
        return res.data
      })
    },
    uploadUserImage: ({ commit }, params) => {
      return http.post('/update/avatar', params).then(res => {
        commit('setUserImage', res.data.data)
        return res
      })
    },
    updatePassword: ({ commit }, params) => {
      return http.post('/auth/me/update/password', params).then(res => {
        return res
      })
    },
    login: ({ commit }, params) => {
      return http.post('/auth/login', params).then(res => {
        if (res.data.success) {
          commit('userLogin', res.data.data)
        }
        return res.data
      })
    },
    logout: ({ commit }) => {
      return http.get('/auth/me/logout').then(() => {
        commit('userLogout')
      })
    },
    getUser: ({ commit }) => {
      return http.get('/auth/me').then((res) => {
        commit('setUser', res.data)
      })
    },
    updateUserInfo: ({ commit }, params) => {
      return http.put('/auth/me/' + params.id, params).then(res => {
        commit('setUser', res.data)
      })
    }
  },
  mutations: {
    userLogin (state, data) {
      const accessToken = data.token
      localStorage.setItem('access_token', accessToken)
      localStorage.setItem('user', JSON.stringify(data.user))
      http.defaults.headers.common.Authorization = accessToken
      state.isAuthenticated = true
      state.token = accessToken
      state.user = data.user
    },
    setUserImage (state, data) {
      state.user.avatar_path = data.avatar_path
    },
    userLogout (state) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('user')
      http.defaults.headers.common.Authorization = ''
      state.isAuthenticated = false
      state.access_token = null
      state.user = null
    },
    setUser (state, data) {
      state.user = data.data.user
    }
  },
  getters: {
    user: state => state.user,
    isAuthenticated: state => state.isAuthenticated
  }
}

export default auth
